export const zIndex = {
  sidebar: 5,
  header: 4,
  reconciliation_header: 3,
  openMenu: 10,
};
